import React from "react";
import MuiTextField from "@mui/material/TextField";

const DisplayField2 = React.forwardRef(
    (
        {
            label,
            value,
            defaultValue,
            errorMsg,
            containerClass,
            entityName, //removed due to useless warnings
            virtualKeyboardLayout, //removed due to useless warnings
            virtualKeyboardLang, //removed due to useless warnings
            onChangeInput, //removed due to useless warnings
            InputProps,
            ...restProps
        },
        ref
    ) => {
        return (
            <div className={`from-field-amx ${errorMsg ? "error-field" : ""} ${containerClass || ""}`}>
                <MuiTextField
                    inputRef={ref}
                    variant="standard"
                    label={label}
                    value={value || defaultValue || ""}
                    InputProps={{
                        ...InputProps,
                        readOnly: true
                    }}
                    {...restProps}
                />
                {errorMsg && <span className="helperTextError">{errorMsg}</span>}
            </div>
        );
    }
);

export default DisplayField2;
